import { createApp } from "vue";
import App from "./App.vue";
import "@/assets/scss/index.scss";
// Router
import router from "./router";
// Store
import store from "./store";
// Directives
import VueObserveVisibility from "vue3-observe-visibility";
import VScrollLock from "v-scroll-lock";
// Plugins
import { i18n } from "./i18n";
import plugin from "vue-toastify";
import "vue-toastify/index.css";
// Services
import { initInterceptors } from "@/services/http/client";
// Utils
import "focus-visible";
import getHttpErrorHandler from "@/services/http/interceptors/errorHandler";
import { AppWithI18n } from "@/types/appWithI18n";

const app = createApp(App) as AppWithI18n;

app.use(router);
app.use(store);
app.use(i18n);
app.use(VueObserveVisibility);
app.use(VScrollLock);
app.use(plugin, {
  position: "top-center",
  theme: "light",
  hideProgressbar: true,
  singular: true,
  oneType: true,
});
app.mount("#app");
initInterceptors(getHttpErrorHandler(app));
